import React, { useState } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import dayjs from 'dayjs'
import { profileSelector } from '../reducers/profile'
import { deleteSessionUnauthorize } from '../actions/api'
import CookieAccessor from '../utils/cookieAccessor'
import get from 'lodash/get'

import '../styles/header.scss'

function Header({ profile, deleteSessionUnauthorize }) {
  const [loading, setLoading] = useState(false)

  let renderInfo
  if (get(profile, 'name')) {
    renderInfo = get(profile, 'name')
  } else if (get(profile, 'googleIdentity.name')) {
    renderInfo = get(profile, 'googleIdentity.name')
  } else if (get(profile, 'facebookIdentity.name')) {
    renderInfo = get(profile, 'facebookIdentity.name')
  } else if (get(profile, 'vkIdentity.name')) {
    renderInfo = get(profile, 'vkIdentity.name')
  } else if (get(profile, 'phoneIdentity.normalizedNumber')) {
    renderInfo = parsePhoneNumberFromString(`+${get(profile, 'phoneIdentity.normalizedNumber')}`).formatInternational()
  } else if (get(profile, 'email')) {
    renderInfo = get(profile, 'email')
  }

  const handleLogoutClick = async () => {
    setLoading(true)
    await deleteSessionUnauthorize()
    try {
      localStorage.removeItem('userName');
      const sessionKey = process.env.REACT_APP_SESSION_KEY
      CookieAccessor.expireCookie(sessionKey)
      window.location = '/account'
    } catch (error) {
      console.log('[logout] expire cookie error', error)
    }
    setLoading(false)
  }

  return (
    <div className="account-header">
      <div className="account-header__account" />
      <div className="account-header__meta">
        <div className="account-header__name">{renderInfo}</div>
        <div className="account-header__date">
          Дата регистрации: {dayjs.unix(profile.createdAt).format('DD MMMM YYYY г.')}
        </div>
      </div>
      <button
        className={classnames('account-header__logout', { 'account-header__logout--loading': loading })}
        onClick={handleLogoutClick}
        disabled={loading}>
        <span>Выйти</span>
      </button>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector
})

export default connect(mapStateToProps, { deleteSessionUnauthorize })(React.memo(Header))
